module.exports = __webpack_public_path__ + "02eaf890554bb968.png";